<template>
  <el-dialog
    class="radish-dia"
    :title="'进展列表 ' + name"
    top="70px"
    :modal="false"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div v-for="(item, index) in remarks" :key="index" class="interview-list-row">
      <span class="remark-date">
        {{ getDate(item.data.createdAt) }} <span class="remark-time">{{ getTime(item.data.createdAt) }}</span> --
        {{ item.data.顾问 }}
      </span>
      <span class="remark-info pd-10">
        <el-tag size="mini">{{ item.type }}</el-tag>
        <el-tag v-if="item.type === '面试'" size="mini">第{{ item.data.round }}轮</el-tag>
        <el-tag v-if="item.type === '面试' && item.data.结果" size="mini"> {{ item.data.结果 }}</el-tag>
        <i class="el-icon-info" style="margin-left:8px" />
        <span v-if="!showType.includes(item.data._id)" @click="showMore(item.data)">查看详情</span>
        <span v-else @click="showMore(item.data)">收起</span>
        <span v-if="item.type === '面试'" class="interview-grade-btn" @click="showInterviewGrade(item.data.round)"
          >面试评价</span
        >
      </span>
      <div v-if="item.type === '到岗' && showType.includes(item.data._id)" class="radish-dia-type">
        <span class="display">职位：{{ towork.职位 }}</span>
        <span class="display">专业职级：{{ towork.专业职级 }}</span>
        <span class="display">固定年薪：{{ towork.固定年薪 }}</span>
        <span class="display">到岗日期: {{ towork.到岗日期 }}</span>
        <span class="display">试用期: {{ towork.试用期 }}</span>
      </div>
      <div v-if="item.type === 'offer' && showType.includes(item.data._id)" class="radish-dia-type">
        <span class="display">职位：{{ offer.职位 }}</span> <span class="display">专业职级：{{ offer.专业职级 }}</span>
        <span class="display">固定年薪：{{ offer.固定年薪 }}</span>
        <span class="display">offer签订日期: {{ offer.offer签订日期 }}</span>
        <span class="display">预计到岗时间: {{ offer.预计到岗时间 }}</span>
      </div>
      <!-- TODO: 显示问题，表格已收起，切换状态时，已收起的表格会重新展开 -->
      <!-- 人才面试反馈 -->
      <div
        v-if="item.type === '面试' && showType.includes(item.data._id)"
        class="radish-dia-type"
        style="padding-left:0;"
      >
        <el-table :data="[item.data]" size="mini" default-expand-all border :resizable="false" style="width: 100%">
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-form label-position="left" inline class="inter-table-expand">
                <el-form-item label="面试官:">
                  <span>{{ props.row['面试官'] }}</span>
                </el-form-item>
                <el-form-item label="面试时长:">
                  <span>{{ props.row['面试时长'] }}</span>
                </el-form-item>
                <el-form-item label="沟通情况:">
                  <span>{{ props.row['沟通情况'] }}</span>
                </el-form-item>
                <el-form-item label="意向:">
                  <span>{{ props.row['意向'] }}</span>
                </el-form-item>
                <el-form-item label="诉求:">
                  <span>{{ props.row['诉求'] }}</span>
                </el-form-item>
                <el-form-item label="目前薪酬:">
                  <span>{{ props.row['目前薪酬'] }}</span>
                </el-form-item>
                <el-form-item label="目前职级:">
                  <span>{{ props.row['目前职级'] }}</span>
                </el-form-item>
                <el-form-item label="备注:">
                  <span>{{ props.row['面试反馈备注'] }}</span>
                </el-form-item>
                <el-form-item v-if="props.row['淘汰理由']" label="淘汰理由:">
                  <span>{{ props.row['淘汰理由'] }}</span>
                </el-form-item>
              </el-form>
            </template>
          </el-table-column>
          <el-table-column label="面试时间" prop="面试时间" width="90"> </el-table-column>
          <el-table-column label="轮数" prop="round" width="60">
            <template slot-scope="props">
              <span>第{{ props.row.round }}轮</span>
            </template>
          </el-table-column>
          <el-table-column label="联系人" prop="联系人"> </el-table-column>
          <el-table-column label="联系电话" prop="联系电话"> </el-table-column>
          <el-table-column label="面试地址" prop="面试地址"> </el-table-column>
          <el-table-column label="面试官" prop="面试官"> </el-table-column>
          <el-table-column label="终面" prop="isFinal" width="50">
            <template slot-scope="props">
              <span>{{ props.row.isFinal ? '是' : '否' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="备注" prop="备注" width="50">
            <template slot-scope="props">
              <el-tooltip class="item" effect="dark" :content="props.row.备注" placement="top">
                <span v-if="props.row.备注" class="company-pointer">查看</span>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 客户面试反馈 -->
      <div v-if="item.type === '面试' && showType.includes(item.data._id)" class="radish-dia-type">
        <span>面试轮数：第{{ item.data.round }}轮</span>
        <pre>{{ item.data.客户备注 }}</pre>
        <div>
          <span v-for="tag in getTags(item.data.客户反馈)" :key="tag" class="label_tag">{{ tag }}</span>
        </div>
      </div>
      <div v-if="item.type === '淘汰' && showType.includes(item.data._id)" class="radish-dia-type">
        <span class="display">顾问: {{ recommend.顾问 }}</span>
        <span class="display">淘汰时间: {{ getDate(recommend.updatedAt) }}</span>
        <div class="display">淘汰理由: {{ recommend.淘汰理由 }}</div>
      </div>
      <div v-if="item.type === '推荐' && showType.includes(item.data._id)" class="radish-dia-type">
        <span class="display">推荐顾问: {{ recommend.顾问 }}</span>
        <span class="display">推荐时间: {{ getDate(recommend.createdAt) }}</span>
      </div>
    </div>
    <footer></footer>
  </el-dialog>
</template>
<script>
const dateFormat = require('dateformat')

export default {
  data: function() {
    return {
      dialogVisible: false,
      interviews: [],
      name: '',
      recommend: {},
      offer: {},
      towork: {},
      remarks: [],
      showType: [],
      expandAll: {},
      matchField: { rid: '', pid: '' },
    }
  },
  methods: {
    showInterviewGrade(round) {
      const option = Object.assign({}, { round }, this.matchField)
      app.root.$refs.InterviewGrade.open(option)
    },
    show: async function(param) {
      const { rid, pid } = param
      this.matchField = { rid, pid }
      this.name = param['姓名']
      const res = await app.service('radish').listInterviews({ rid: rid, pid: pid })
      if (res.status == 'success') {
        this.interviews = res.data
        const fields = ['recommend', 'offer', 'towork']
        fields.forEach(field => {
          this[field] = res[field] || {}
        })
        this.getRecord()
      } else {
        this.$message.error(res.msg)
      }
      this.dialogVisible = true
    },
    showMore(item) {
      this.showType.includes(item._id)
        ? (this.showType = this.showType.filter(val => val !== item._id))
        : this.showType.push(item._id)
    },
    getTime(time) {
      return dateFormat(new Date(time), 'HH:MM')
    },
    getRecord() {
      const result = []
      if (Object.keys(this.towork).length !== 0) result.push({ type: '到岗', data: this.towork })
      if (Object.keys(this.offer).length !== 0) result.push({ type: 'offer', data: this.offer })
      if (this.interviews.length !== 0) {
        this.interviews.forEach(interview => {
          result.push({ type: '面试', data: interview })
        })
      }
      if (Object.keys(this.recommend).length !== 0) {
        if (this.recommend.结果 === '淘汰') {
          result.push({
            type: '淘汰',
            data: { _id: `${this.recommend._id  }e`, createdAt: this.recommend.updatedAt, 顾问: this.recommend.顾问 },
          })
        }
        result.push({ type: '推荐', data: this.recommend })
      }
      this.remarks = result
    },
    async getOffers(query) {
      const res = await app.service('radish').listOffers(query)
      if (res.status == 'success') {
        this.offers = res.data
      } else {
        this.$message.error(res.msg)
      }
    },
    getDate(val) {
      return dateFormat(new Date(val), 'yyyy/mm/dd')
    },
    getTags(obj) {
      const tagData = obj || {}
      let tags = []
      const fields = ['leadership', 'personal', 'professional', 'mentality', 'other']
      fields.forEach(field => {
        tags = tagData[field] ? tags.concat(tagData[field]) : tags
      })
      return tags
    },
  },
}
</script>
<style>
.inter-table-expand {
  font-size: 0;
  padding: 5px 10px;
}
.inter-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.inter-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 100%;
}
</style>
<style scoped>
ul {
  list-style: none;
  padding: 0;
}
.display {
  margin: 0 20px 4px 0;
  display: block;
  float: left;
}
.radish-dia-type {
  padding: 10px 0 0 20px;
  overflow: auto;
}
.interview-list-row::after {
  content: '';
  width: 100%;
  height: 1px;
  background-color: #eee;
  display: block;
  margin: 4px 0;
}
footer {
  width: 100%;
  height: 15px;
}
.interview-grade-btn {
  float: right;
  color: #409eff;
}
</style>
